import { cn } from "@/lib/utils";

export function FitBadge({ value }: { value: number | null }) {
  if (value === null) {
    return <span className="text-muted-foreground">–</span>;
  }
  const tone =
    value >= 75
      ? "bg-primary/20 text-primary border-primary/30"
      : value >= 50
      ? "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30"
      : "bg-muted text-muted-foreground border-border";
  return (
    <span
      className={cn(
        "inline-flex h-6 min-w-[2.75rem] items-center justify-center rounded-full border px-2 font-mono text-xs font-semibold tabular-nums",
        tone,
      )}
    >
      {value}%
    </span>
  );
}
